import $ from "jquery";
import { u_ } from "@@assets/scripts/app";
import vuwer from "@@assets/scripts/vuwer";

vuwer.add("pageNav", {
	selector: "#page_nav",
	
	onReady($self) {
		if(!$self) {
			return false;
		}
		
		const $menu = $self.children(".nav-menu");
		const $title = $menu.children(".menu-title");
		
		this.setProp({ $menu, $title });
	},
	
	updateTitle(text) {
		if(!this.$title) {
			return false;
		}
		
		this.$title.text(text);
		
		return this;
	},
	
	updateList(list, addMode) {
		if(!this.$menu) {
			return false;
		}
		
		!addMode && this.$menu.children(".menu-item").remove();
		
		if( Array.isArray(list) && list.length ) {
			$.fn.append.apply(
				this.$menu,
				list.map(item => {
					if( !u_.isObject(item) ) {
						return undefined;
					}
					
					const { className, url, text, changeState } = item;
					const classList = ["menu-item"];
					!!className && classList.push(className);
					
					const $a = $("<a/>").attr("href", `./${url || ""}`);
					!!changeState && $a.addClass("change-state");
					
					$a.append( $("<span/>").text(text || "") );
					
					return $("<dd/>").addClass( classList.join(" ") ).append($a);
				})
			);
		}
		
		return this;
	},
	
	onChangeState(state) {
		if(!this.$menu) {
			return false;
		}
		
		if(state.active !== this.state.active) {
			this.$menu.children(".is-active").removeClass("is-active");
			
			if( state.active && u_.isString(state.active) ) {
				this.$menu.children(`.${state.active}`).addClass("is-active");
			}
		}
	}
});
